import { render, staticRenderFns } from "./ProtalHeader.vue?vue&type=template&id=46c75f41&scoped=true"
import script from "./ProtalHeader.vue?vue&type=script&lang=js"
export * from "./ProtalHeader.vue?vue&type=script&lang=js"
import style0 from "./ProtalHeader.vue?vue&type=style&index=0&id=46c75f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c75f41",
  null
  
)

export default component.exports